import { PieceFilterAmountListElementData } from "./pieceFilterAmountListElement";


import AmountIncrease from "../../components/amountIncrease";
import { InstrumentAmountDTO, InstrumentAmountDTOInstrumentEnum } from "../../openapi-generated-client";
import PieceFilterList from "./pieceFilterList";
import { getInstrument, getInstrumentEnumById } from "../../data/instrumentManager";

interface PieceFilterInstrumentListProps {
    instruments: Array<InstrumentAmountDTO>;
    instrumentsChosen: InstrumentAmountDTO[];
    setInstrumentsChosen: (v: InstrumentAmountDTO[]) => void;
    maxElements: number;
    instrumentAmount: number;
    setInstrumentAmount: (v: number) => void;
}

export default function PieceFilterInstrumentList(props: PieceFilterInstrumentListProps) {

    var instrumentsAvailable: PieceFilterAmountListElementData[] = [];

    for(var instrumentData of props.instruments) {
        if(!instrumentData.instrument) continue;
        var instrument = getInstrument(instrumentData.instrument);
        if(instrument) {
            if(props.instrumentsChosen.find(i => i.instrument === instrumentData.instrument)) {
                continue;
            }
            instrumentsAvailable.push(new PieceFilterAmountListElementData(instrument.name, instrumentData.amount ? instrumentData.amount : 0, instrument.id, instrument.icon));
        }
    }

    var instruments: PieceFilterAmountListElementData[] = [];
    for(var chosenInstrument of props.instrumentsChosen) {
        if(!chosenInstrument.instrument) continue;
        var instrument = getInstrument(chosenInstrument.instrument);
        if(instrument) {
            instruments.push(new PieceFilterAmountListElementData(instrument.name, chosenInstrument.amount ? chosenInstrument.amount : 1, instrument.id));
            instrumentsAvailable.splice(instruments.length-1, 0, new PieceFilterAmountListElementData(instrument.name, props.instruments.find(i => i.instrument === chosenInstrument.instrument)?.amount ?? 0, instrument.id, instrument.icon));
        }
    }

    return <>
    
        <PieceFilterList maxElements={props.maxElements} options={instrumentsAvailable} active={instruments} onUpdate={(v: PieceFilterAmountListElementData[]) => {
                var newInstruments: InstrumentAmountDTO[] = [];
                for(var data of v) {
                    var instrument: InstrumentAmountDTOInstrumentEnum | undefined = getInstrumentEnumById(data.id);
                    if(instrument) {
                        newInstruments.push({
                            instrument: instrument,
                            amount: data.amount
                        });
                    }else {
                        console.log("Instrument enum not found for instrument id " + instrument);
                        continue;
                    }
                }
                var containsAccordion = false;
                for(var instr of newInstruments) {
                    if(instr.instrument === InstrumentAmountDTOInstrumentEnum.Accordion) {
                        containsAccordion = true;
                        break;
                    }
                }
                if(!containsAccordion) {
                    newInstruments.push({
                        instrument: InstrumentAmountDTOInstrumentEnum.Accordion,
                        amount: 1
                    });
                }
                props.setInstrumentsChosen(newInstruments);
            }}/>
        <h4 className={"total-amount" + (props.instrumentAmount == -1 ? " disabled"  : "")}>Total Instruments: <AmountIncrease placeholder={props.instrumentAmount == -1 ? "all" : ""} amount={props.instrumentAmount > 0 ? props.instrumentAmount : 1} onChange={(v: number) => {
            if(props.instrumentAmount == -1) {
                props.setInstrumentAmount(1);
                return;
            }
            props.setInstrumentAmount(v);
        }}/></h4>
    </>
}